import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7e2c856"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-6 p-4 container mx-auto" }
const _hoisted_2 = { class: "space-y-4" }
const _hoisted_3 = { class: "flex gap-4 justify-between" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "gap-8" }
const _hoisted_6 = { class: "w-full" }

import {computed, onMounted, onUnmounted, ref, watch,} from "vue";
import CategoryForm from "@/Components/FAQCategories/CategoryForm.vue";
import HcButton from "@/Components/Buttons/Button.vue";
import {throttle} from "lodash";
import Card from "@/Components/General/Card.vue";
import CardBody from "@/Components/General/CardBody.vue";
import route from "ziggy-js"

//@ts-ignore
import * as tailwindConfig from "../../../../tailwind.config.mjs";
import {Option} from "@/types/LevelsSelectTypes";
import FaqCategory from "@/types/FaqCategory";
import {Inertia} from "@inertiajs/inertia";
import Messages from "@/Components/General/Messages.vue";


interface Props {
  categories: FaqCategory[];
  selectedCategory?: FaqCategory | null | undefined;
}


import AppLayoutVue from "@/Layouts/AppLayout.vue";


const __default__ = {
  layout: AppLayoutVue,

}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  ...{
},
  __name: 'CreateOrUpdate',
  props: {
    categories: {},
    selectedCategory: {}
  },
  setup(__props: any) {

const props: Props = __props;



const category = ref(props.selectedCategory ? {
  id: props.selectedCategory.id,
  title: props.selectedCategory.title,
  parent_id: props.selectedCategory.parent_id,
  options: mapCategories(props.selectedCategory.sub_categories as any, 2),
} : null)
const selectedOptionId = ref(category.value?.id ?? null);
const createNew = ref(route().current("faq-categories.create"));
const screenWidth = ref(window.innerWidth);

watch(
    () => selectedOptionId.value,
    function () {
      if (selectedOptionId.value) {
        createNew.value = false;
      }
    }
);


function mapCategories(categories: FaqCategory[], levels: number): Option[] {

  if (levels == 0) {
    return [];

  }
  return categories.map((category: FaqCategory) => ({
    id: category.id,
    label: category.title,
    parent_id: category.parent_id,
    expandable: category.sub_categories && category.sub_categories.length > 0,
    options: category.sub_categories ? mapCategories(category.sub_categories, levels - 1) : [],
  }))
}

const options = mapCategories(props.categories as any, 3);
const selectCategory = () => {
  if (
      route().current("faq-categories.index") ||
      route().current("faq-categories.show")
  ) {
    Inertia.visit(
        route("faq-categories.show", selectedOptionId.value as any) +
        window.location.search,
        {}
    );
  } else {
    Inertia.get(
        route("faq-categories.show", selectedOptionId.value as any) +
        window.location.search
    );
  }
}

watch(
    () => selectedOptionId.value,
    function () {
      if (selectedOptionId.value) {
        selectCategory();
      }
    }
);
const onDeleted = () => {
  Inertia.visit(route("faq-categories.index"));
};



const onResize = throttle((e) => {
  screenWidth.value = e.target.innerWidth;
}, 100);

onMounted(() => {
  window.addEventListener("resize", onResize);
});

onUnmounted(() => {
  window.removeEventListener("resize", onResize);
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Messages, { class: "attribute-index-messages" }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(route)().current() == 'faq-categories.create' ? 'Ny ' : "Oppdater ") + " kategori", 1),
        _createElementVNode("div", null, [
          _createVNode(HcButton, {
            color: "gray",
            type: "inertia-link",
            href: _unref(route)('faq-categories.index')
          }, {
            default: _withCtx(() => [
              _createTextVNode("Avbryt ")
            ]),
            _: 1
          }, 8, ["href"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(Card, null, {
            default: _withCtx(() => [
              _createVNode(CardBody, null, {
                default: _withCtx(() => [
                  _createVNode(CategoryForm, {
                    category: category.value as any,
                    onDeleted: onDeleted,
                    categories: _unref(options)
                  }, null, 8, ["category", "categories"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})